import { useCallback, useContext, useMemo } from "react";

// Context
import { AnalyticsContext } from "@swiggy-private/checkout-core";

// types
import { CroutonComms } from "@swiggy-private/cart-types";

// constants
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";

export const useBlackOtpWidgetsAnalytics = (croutonComms: CroutonComms) => {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);

    const croutonContextValue = useMemo(() => JSON.stringify(croutonComms?.subtitles), [croutonComms]);

    const onImpressionFtueHalfcard = useCallback(
        () =>
            impressionEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: IMPRESSION_ACTIONS.IMPRESSION_ONE_BLACK_HALFCARD,
                context: "",
            }),
        [impressionEvent],
    );

    const onClickFtueClose = useCallback(
        () =>
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_ONE_BLACK_HALFCARD_CLOSE,
                context: "",
            }),
        [clickEvent],
    );

    const onClickFtueCta = useCallback(
        () =>
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_ONE_BLACK_HALFCARD_CTA,
                context: "",
            }),
        [clickEvent],
    );

    const onImpressionCrouton = useCallback(
        () =>
            impressionEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: IMPRESSION_ACTIONS.IMPRESSION_OTP_CROUTON,
                context: croutonContextValue,
            }),
        [impressionEvent, croutonContextValue],
    );

    const onClickCroutonClose = useCallback(
        () =>
            clickEvent({
                category: SCREEN_NAME.CHECKOUT,
                action: CLICK_ACTIONS.CLICK_OTP_CROUTON_CLOSE,
                context: croutonContextValue,
            }),
        [clickEvent, croutonContextValue],
    );

    return {
        onImpressionFtueHalfcard,
        onClickFtueClose,
        onClickFtueCta,
        onImpressionCrouton,
        onClickCroutonClose,
    };
};
